import {
  convertFromAtlasPosition,
  convertFromGeoLocationToPositionType,
  getGeoDistance,
  round,
} from 'app/src/features/Showcase/helpers/maputils'
import { companyagreementApi } from 'app/src/services/welfareportal'
import { ListItemRenderer } from 'app/src/shared/components'
import { ProductSubcategoryCard } from 'app/src/shared/components/ProductSubcategoryCard/ProductSubcategoryCard'
import type atlas from 'azure-maps-control'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function ProductList(props: {
  products?: companyagreementApi.ProductPaginated
  categories?: companyagreementApi.Category[]
  onProductSelection: (productId: string) => void
  onCategorySelection: (categoryId: string) => void
  loadMoreProducts: (limit: number, offset: number) => void
  loadingProducts: boolean
  loadingCategories: boolean
  showMap: boolean
  navigatorPosition?: atlas.data.Position
  parentSelectedCategoryItem?: companyagreementApi.Category
}): ReactElement {
  const { t } = useTranslation('catalog', { keyPrefix: 'Catalog.Showcase' })

  return (
    <>
      {props.categories && !props.loadingCategories && (
        <div
          className='cat grid grid-cols-1 gap-4 p-2 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2'
          data-testid='ProductList-ProductSubcategoryCard'
        >
          {props.categories?.map((category: companyagreementApi.Category) => (
            <ProductSubcategoryCard
              key={category.categoryId}
              mainImage={category.mainImage}
              parentCategoryImage={props.parentSelectedCategoryItem?.mainImage}
              name={category.categoryName ?? ''}
              description={category.description}
              isSubcategory
              onClick={() => props.onCategorySelection(category.categoryId)}
            ></ProductSubcategoryCard>
          ))}
        </div>
      )}
      {props.products && !props.loadingCategories && (
        <ListItemRenderer
          data={props.products}
          loading={props.loadingProducts}
          loadMore={props.loadMoreProducts}
          renderItem={(product: companyagreementApi.ProductListItem) => (
            <ProductSubcategoryCard
              key={product.productId}
              mainImage={product.mainImage}
              parentCategoryImage={props.parentSelectedCategoryItem?.mainImage}
              name={product.productName ?? ''}
              isPartnership={product.additionalInfo?.partnership ? true : false}
              description={
                (props.showMap && product.geoAddress ? (
                  <div>
                    <div className='line-clamp-2 min-h-[50px]'>{product.geoAddress}</div>
                    {props.navigatorPosition && product.geoLocation && (
                      <div
                        className='line-clamp-1'
                        dangerouslySetInnerHTML={{
                          __html: t('Map.distance', {
                            DISTANCE: round(
                              getGeoDistance(
                                convertFromAtlasPosition(props.navigatorPosition),
                                convertFromGeoLocationToPositionType(product.geoLocation),
                              ) / 1000,
                              2,
                            ),
                          }),
                        }}
                      ></div>
                    )}
                  </div>
                ) : (
                  product.description
                )) ?? ''
              }
              onClick={() => {
                props.onProductSelection(product.productId!)
              }}
              isFavourite={product?.isFavourite}
            ></ProductSubcategoryCard>
          )}
          pt={{
            container: { className: 'prod grid grid-cols-1 gap-4 p-2 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2' },
          }}
        />
      )}
    </>
  )
}
